module.exports = __webpack_public_path__ + "img/bangyangrenwu-1@3x.13fa0bcd.png";